module.exports = "/shared/fonts/proxima-nova-regular.otf";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/proxima-nova-regular.otf
// module id = 19
// module chunks = 13